import { SvgLogo, SvgLogoProps } from './SvgLogo';

export const Dyn = ({ height, width, ...props }: SvgLogoProps) => (
  <SvgLogo
    data-test="Dyn"
    height={height}
    width={width}
    title="Dyn Logo"
    titleId="dyn-logo-title"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <path
      d="M16.7934 41.2419C19.7923 41.1105 22.6224 40.4347 25.2276 39.3083C15.1628 36.455 7.79695 27.1816 7.79695 16.2C7.79695 13.1402 8.37798 10.2117 9.40882 7.52734C7.10348 8.25945 5.04178 9.46086 3.61734 11.3005C1.33073 14.9798 0 19.3349 0 23.9904C0 28.6271 1.31199 32.9446 3.57985 36.6239C5.60406 39.4022 12.5014 41.4296 16.7934 41.2419Z"
      fill="url(#dyn-logo-gradient-1)"
    />
    <path
      d="M39.4159 25.8678C40.7841 22.9957 41.5526 19.8232 41.5526 16.463C41.5526 11.8264 39.5846 6.06336 36.5483 3.58545C32.8935 1.31404 28.5826 0 23.9532 0C15.3316 0 7.64706 4.5616 3.56116 11.3946C7.23472 9.12319 11.5455 7.79038 16.175 7.79038C27.3644 7.79038 36.7732 15.4869 39.4159 25.8678Z"
      fill="url(#dyn-logo-gradient-2)"
    />
    <path
      d="M36.5482 3.56689C38.9848 7.07726 40.203 11.5074 40.203 16.1441C40.203 29.4159 29.4635 40.1911 16.1937 40.1911C11.5642 40.1911 7.23466 38.8958 3.57983 36.6056C7.77819 43.4762 15.369 48.0002 23.9906 48.0002C37.2417 48.0002 48 37.2439 48 23.9533C47.9812 15.3182 43.3705 7.43393 36.5482 3.56689Z"
      fill="url(#dyn-logo-gradient-3)"
    />
    <defs>
      <linearGradient
        id="dyn-logo-gradient-1"
        x1="1.30565"
        y1="17.6733"
        x2="38.9499"
        y2="35.8737"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopColor="#E6E7E8" />
      </linearGradient>
      <linearGradient
        id="dyn-logo-gradient-2"
        x1="7.3182"
        y1="2.12238"
        x2="34.7611"
        y2="26.1994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#939598" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="dyn-logo-gradient-3"
        x1="22.2966"
        y1="22.3901"
        x2="41.4408"
        y2="40.1067"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FEFAD8" />
        <stop offset="1" stopColor="#FCEE21" />
      </linearGradient>
    </defs>
  </SvgLogo>
);
